import _ from 'lodash'
import webUtils from '@/tools/web-utils'

export default function (target, func) {
  return (requestConfig) => {
    let ajaxFunc = (resolve, reject) => {
      func.call(target, requestConfig).then(
        resolve
        // (response) => {
        // if (typeof response === 'string' && response.includes("<!DOCTYPE html><html>")) {
        //   //302 to login page
        //   webUtils.redirect2QxLogin();
        // } else {
        //   resolve(response)
        // }
        // }
     ).catch(error => {
        window.console.log("error : " + error.request);
      if (isUnAuthorized(error)) {
        webUtils.redirect2QxLogin();
      } else {
        reject(error);
      }
      });
    };
    return new Promise(ajaxFunc);
  }
}

function isUnAuthorized(error) {
  let status = _.at(error, 'response.status')[0];
  return status == 401;
}

